import { defineStore } from 'pinia'
import type { IDirRange } from '../types'
import { dirRange } from '../api'
import type { workspaceItem } from '@/store'
import { useWorkspaceStore } from '@/store'

interface recordWork {
  workspaceId: workspaceItem['workspaceId']
  workspaceType: workspaceItem['workspaceType']
}

export const useFileStructureStore = defineStore('fileStructure', () => {
  const workspaceStore = useWorkspaceStore()
  const currentWorkspace = computed(() => {
    return workspaceStore.currentWorkspace
  })

  const fileStructure = ref<IDirRange[]>([])
  const oldWorkspace = ref<recordWork>()

  function _isChange(params: recordWork) {
    return !fileStructure.value.length || params.workspaceId !== oldWorkspace.value?.workspaceId || params.workspaceType !== oldWorkspace.value?.workspaceType
  }

  async function getFileStructure() {
    const params: recordWork = {
      workspaceId: currentWorkspace.value.workspaceId === -1 ? null : currentWorkspace.value.workspaceId,
      workspaceType: currentWorkspace.value.workspaceType,
    }

    if (_isChange(params)) {
      await _updateFileStructure(params)
      oldWorkspace.value = params
    }

    return fileStructure
  }

  async function _updateFileStructure(params: recordWork) {
    const res = await dirRange(params)

    const workspaceStore = useWorkspaceStore()
    const isPersonal = workspaceStore.isPersonal

    // 企业空间小，不显示个人知识库
    fileStructure.value = isPersonal ? res : res.filter(item => item.name !== '个人知识库')

    return res
  }

  return { getFileStructure, fileStructure, _updateFileStructure, oldWorkspace }
})
